import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import ChatWorkflow from './pages/ChatWorkflow';
import Layout from './components/Layout';
import './App.css';
import { store } from './redux';
import Auth from './pages/Auth';
import PrivateRoute from './components/PrivateRoute';


const App: React.FC = () => {
  return (
    <ConfigProvider>
      <Provider store={store}>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element=
                {
                  <PrivateRoute>
                    <ChatWorkflow />
                  </PrivateRoute>
                }
              />
              <Route path="/login" element={<Auth />} />
            </Routes>
          </Layout>
        </Router>
      </Provider>
    </ConfigProvider>
  );
};

export default App;
